import React, {FC} from 'react';
import { useStoreon } from 'storeon/react';
import { State } from '@/interfaces';
import { AuthorizationPage } from '../../pages';


const GlobalAuthorizationLayout: FC<React.ReactNode> = ({ children }) => {
  const { currentUser } = useStoreon<State>('currentUser');
  return (
    <div>
      {
        !currentUser.status && currentUser.status === false ?
          <AuthorizationPage />
          :
          <>
            {children}
          </>
      }
    </div>
  );
};

export default GlobalAuthorizationLayout;
